import Flickity from 'flickity'

class Sliders {
  constructor() {
    this.init()
  }

  init() {
    if (document.querySelector('.s-frontpage')) {
      const sliders = document.querySelectorAll('.c-slider')
      if (sliders.length > 0) {
        sliders.forEach((slider) => {
          new Flickity(slider, {
            pageDots: true,
            prevNextButtons: false,
            cellSelector: '.c-slider__entry',
            wrapAround: true,
            cellAlign: 'left',
            autoPlay: true,
          })
        })
      }
    }

    /* Custom slider for Artist and Product gallery */
    if (document.querySelector('.s-single-artist') || document.querySelector('.s-single-product')) {
      const main = document.querySelector('.c-slider-gallery__main')
      const thumbnails = document.querySelectorAll('.c-slider-gallery__nav .c-slider-gallery__entry')

      const mainFlickity = new Flickity(main, {
        pageDots: false,
        prevNextButtons: false,
        cellSelector: '.c-slider-gallery__entry',
        on: {
          change: (index) => {
            thumbnails.forEach((thumb) => {
              thumb.classList.remove('is-selected')
            })
            thumbnails[index].classList.add('is-selected')
          },
        },
      })

      thumbnails.forEach((thumb, index) => {
        thumb.addEventListener('click', () => {
          mainFlickity.select(index)
        })
      })
    }

    /* Artist Slider for Video, Discography and Press */
    if (document.querySelector('.s-single-artist')) {
      const sections = document.querySelectorAll('section')
      sections.forEach(async (section) => {
        const slider = section.querySelector('.c-slider')
        const prev = section.querySelector('.js-slider-prev')
        const next = section.querySelector('.js-slider-next')

        let minSlide = 2
        let autoplay = false
        if (section.classList.contains('videos')) minSlide = 1
        if (section.classList.contains('press')) autoplay = true

        if (slider && section.querySelectorAll('.c-slider__entry').length > minSlide) {
          const carousel = new Flickity(slider, {
            pageDots: false,
            prevNextButtons: false,
            cellSelector: '.c-slider__entry',
            wrapAround: true,
            cellAlign: 'left',
            autoplay,
            // adaptiveHeight: true,
          })

          prev.addEventListener('click', () => {
            carousel.previous()
          })
          next.addEventListener('click', () => {
            carousel.next()
          })
        }
      })
    }
  }
}

export default Sliders
